import { NetOpenPositionActions, NetOpenPositionActionTypes } from './NetOpenPositionActions';
import { NetOpenPosition } from '../../model/NetOpenPosition';
import { Json } from '../../model/Json';

export interface NetOpenPositionState {
  records: Json<string, NetOpenPosition>;
  valueDates: Array<string>;
}

export const initialState: NetOpenPositionState = {
  records: {},
  valueDates: []
};

export function netOpenPositionReducer(state: NetOpenPositionState = initialState, action: NetOpenPositionActions):  NetOpenPositionState {
  switch (action.type) {
    case NetOpenPositionActionTypes.InitNetOpenPositions: {
      const netOpenPositions = {};
      action.payload.records.forEach(n => netOpenPositions[n.recid] = n);
      return {
        ...state,
        records: netOpenPositions
      };
    }
    case NetOpenPositionActionTypes.InitNetOpenPositionPairData: {
      return {
        ...state,
        valueDates: action.payload.valuedates
      };
    }
    case NetOpenPositionActionTypes.UpdateNetOpenPosition: {
      return {
        ...state,
        records: {
          ...state.records,
          [action.payload.recid]: action.payload
        }
      };
    }
    case NetOpenPositionActionTypes.RemoveNetOpenPosition: {
      const { [action.payload]: toRemoved, ...rest} = state.records;
      return {
        ...state,
        records: rest,
      };
    }
    case NetOpenPositionActionTypes.AddNetOpenPosition: {
      return {
        ...state,
        records: {
          ...state.records,
          [action.payload.recid]: action.payload
        }
      };
    }
  }
  return state;
}

export const initNetOpenPositionState = (state: NetOpenPositionState) => state.records;
export const initNetOpenPositionPairDataState = (state: NetOpenPositionState) => state.valueDates;
